import React from 'react';
import './ButtonRounded.scss';

export default function ButtonRounded({ children, className, onClick, href, onMouseEnter, onMouseLeave}) {
    const classes = `btn-rounded ${className}`;

    return href ? (
        <a href={href} className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className="btn-content">
                {children}
            </div>
        </a>
    ) : (
        <button className={classes} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <div className="btn-content">
                {children}
            </div>
        </button>
    );
}
